import { GAME_ID, REDUX_ACTIONS, MIN_ATTEMPTS_AT_ITEM_FOR_MASTERY } from '../../data/constants';

const initState = {
  wrongCount: 0,
  isClosingStdItem: false,
  backButtonDisabled: false,
  strikeCount: 0,
  records: [],
};

const submittedAnswersReducer = (state = initState, { type, gameId, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.START_LEVEL:
      return {
        ...state,
        strikeCount: payload.strikeCount,
        records: payload.records ?? [],
      };

    case REDUX_ACTIONS.INITIALIZE_STANDARD_ITEM:
      return {
        ...state,
        wrongCount: 0,
        isClosingStdItem: false,
        backButtonDisabled: false,
      };

    case REDUX_ACTIONS.SET_ITEM_PART:
      return {
        ...state,
        wrongCount: 0,
      };

    case REDUX_ACTIONS.UPDATE_RECORDS: {
      return {
        ...state,
        records: [...state.records, payload.record],
      };
    }

    case REDUX_ACTIONS.MARK_ITEM_AS_COMPLETE:
    case REDUX_ACTIONS.FAIL_STD_ITEM:
      return {
        ...state,
        isClosingStdItem: true,
      };

    case REDUX_ACTIONS.INCREMENT_WRONG_COUNT: {
      const wrongCount = state.wrongCount + 1;
      return {
        ...state,
        wrongCount,
        backButtonDisabled: true,
        strikeCount: wrongCount === MIN_ATTEMPTS_AT_ITEM_FOR_MASTERY ? state.strikeCount + 1 : state.strikeCount,
      };
    }

    case REDUX_ACTIONS.UPDATE_INFERENCE_STATE:
      return {
        ...state,
        backButtonDisabled: true,
      };

    default:
      return state;
  }
};

export default submittedAnswersReducer;
